// Company Settings service - moved from database.js
import { 
  doc, 
  getDoc, 
  setDoc, 
  serverTimestamp, 
  db,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  storage
} from '../../utils/database/firebase-config';

export const companySettingsService = {
  async getCompanySettings(companyId) {
    const settingsRef = doc(db, 'companySettings', companyId);
    const snapshot = await getDoc(settingsRef);
    if (snapshot.exists()) return { id: snapshot.id, ...snapshot.data() };
    return null;
  },
  async updateCompanySettings(companyId, settingsData) {
    const settingsRef = doc(db, 'companySettings', companyId);
    await setDoc(settingsRef, { ...settingsData, updatedAt: serverTimestamp() }, { merge: true });
    return true;
  },
  async uploadCompanyLogo(companyId, file) {
    console.log('Uploading company logo:', { companyId, fileName: file.name, size: file.size });
    
    try {
      const storageRef = ref(storage, `company-logos/${companyId}/${file.name}`);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      await this.updateCompanySettings(companyId, { logoUrl: downloadURL, logoFileName: file.name });
      console.log('Logo upload completed:', downloadURL);
      
      return downloadURL;
    } catch (error) {
      console.error('Logo upload failed:', error.code, error.message);
      throw error;
    }
  },
  async deleteCompanyLogo(companyId, logoFileName) {
    if (logoFileName) {
      const storageRef = ref(storage, `company-logos/${companyId}/${logoFileName}`);
      await deleteObject(storageRef);
    }
    await this.updateCompanySettings(companyId, { logoUrl: null, logoFileName: null });
    return true;
  }
}; 